import api from './api'

class InfoService {
    // 获取所有信息类型
    static async getInfoTypes() {
        const response = await api.get('/infogather/get_info_types/')
        return response.data
    }

    // 获取所有人员信息
    static async getPeople() {
        const response = await api.get('/infogather/get_people/')
        return response.data
    }

    // 获取所有信息
    static async getInfos() {
        const response = await api.get('/infogather/get_infos/')
        return response.data
    }

    // 解析原始信息
    static async parseInfo(data) {
        const response = await api.post('/infogather/parse_info/', data)
        return response.data
    }

    // 保存解析后的信息
    static async saveParsedInfo(data) {
        const response = await api.post('/infogather/save_parsed_info/', data)
        return response.data
    }

    // 检查信息是否重复
    static async checkDuplicate(data) {
        const response = await api.post('/infogather/check_duplicate/', data)
        return response.data
    }

    // 创建信息类型
    static async createInfoType(data) {
        const response = await api.post('/infogather/create_info_type/', data)
        return response.data
    }

    // 创建人员
    static async createPeople(data) {
        const response = await api.post('/infogather/create_people/', data)
        return response.data
    }

    // 更新人员
    static async updatePeople(id, data) {
        const response = await api.put(`/infogather/update_people/${id}/`, data)
        return response.data
    }

    // 删除人员
    static async deletePeople(id) {
        const response = await api.delete(`/infogather/delete_people/${id}/`)
        return response.data
    }

    // 创建信息
    static async createInfo(data) {
        const response = await api.post('/infogather/create_info/', data)
        return response.data
    }

    // 更新信息
    static async updateInfo(id, data) {
        const response = await api.put(`/infogather/update_info/${id}/`, data)
        return response.data
    }

    // 删除信息
    static async deleteInfo(id) {
        const response = await api.delete(`/infogather/delete_info/${id}/`)
        return response.data
    }
}

export default InfoService